/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Study_SInputs */

const en_funnel_ob_seg_study_s = /** @type {(inputs: Funnel_Ob_Seg_Study_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papers, textbooks, lecture notes`)
};

const es_funnel_ob_seg_study_s = /** @type {(inputs: Funnel_Ob_Seg_Study_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos, libros de texto, apuntes de clase`)
};

/**
* | output |
* | --- |
* | "Papers, textbooks, lecture notes" |
*
* @param {Funnel_Ob_Seg_Study_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_study_s = /** @type {((inputs?: Funnel_Ob_Seg_Study_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Study_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_study_s(inputs)
	return en_funnel_ob_seg_study_s(inputs)
});